export default "__VITE_ASSET__BKDf1NY4__"